import { styled } from "styled-components";
import { useEffect, useRef, useState } from "react";
import { SpineStage, SpineStageRef } from "@lindar-joy/goosicorn-quickies-library";
import { DiamondsProps } from "./Diamonds.types";
import { useWindowSize } from "@uidotdev/usehooks";

const StyledStage = styled(SpineStage)<{ $scale: number }>`
    position: absolute;
    width: 598px;
    height: 598px;
    z-index: 1;
    transform: scale(${ props => props.$scale * Math.max(1, devicePixelRatio) });
    transform-origin: top left;
    top: 0;
    left: 0;
    pointer-events: none;
`;

function getSpineObjects() {
    const explosions: any = [];
    for (let y = 0; y < 5; y++) {
        for (let x = 0; x < 5; x++) {
            explosions.push({
                path: "assets/spine/Diamond",
                id: `diamond-${x}-${y}`,
                scale: {
                    x: 0.2,
                    y: 0.2
                },
                x: 60 + 120 * x,
                y: -75 + -120 * y
            });
        }
    }
    return explosions;
}

const Diamonds: React.FC<DiamondsProps> = ({
    diamondLocationX,
    diamondLocationY,
    diamondFound,
    bombTriggered,
    foundDiamonds,
    visible,
    
    ...props
}) => {
    useWindowSize();
    const stageRef = useRef<SpineStageRef>(null);
    const [loaded, setLoaded] = useState<boolean>(false);
    const blocksWidth = document.getElementById("block-container")?.clientWidth;

    async function playAnimation(x: number, y: number) {
        const stage = stageRef.current as SpineStageRef;
        await stage.play(`diamond-${x}-${y}`, "Reveal", false);
        stage.play(`diamond-${x}-${y}`, "Idle", true);
        stage.setVisible(`diamond-${x}-${y}`, true);
        console.log(stage.getSkeleton(`diamond-${x}-${y}`));
    }

    function reset() {
        const stage = stageRef.current as SpineStageRef;
        
        for (let y = 0; y < 5; y++) {
            for (let x = 0; x < 5; x++) {
                stage.stop(`diamond-${x}-${y}`);
            }
        }
    }

    useEffect(() => {
        if (foundDiamonds && loaded) {
            const stage = stageRef.current as SpineStageRef;
            foundDiamonds.forEach( foundDiamond => {
                stage.play(`diamond-${foundDiamond.x}-${foundDiamond.y}`, "Idle", true);
            });
        }

    }, [ foundDiamonds, loaded ]);

    useEffect(() => {
       
        if (diamondFound && loaded) {
            playAnimation(diamondLocationX, diamondLocationY);
        } else if (!bombTriggered) {
            reset();
        }
    }, [ diamondFound, bombTriggered, diamondLocationX, diamondLocationY, loaded ])

    return (
        
        // @ts-ignore
        <StyledStage width={598} height={598} stageId="diamonds" spineObjects={getSpineObjects()} $scale={ blocksWidth / 598 } visible={ visible } onLoad={() => setLoaded(true)} {...props} ref={stageRef}></StyledStage>
        
    );
};

export default Diamonds;